import { render, staticRenderFns } from "./projectFooter.vue?vue&type=template&id=3f996398&scoped=true"
import script from "./projectFooter.vue?vue&type=script&lang=js"
export * from "./projectFooter.vue?vue&type=script&lang=js"
import style0 from "./projectFooter.vue?vue&type=style&index=0&id=3f996398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f996398",
  null
  
)

export default component.exports